// @flow

export const CAMERA_ERRORS = {
	PermissionDeniedError: "PERMISSION_DENIED",
	DevicesNotFoundError: "NO_DEVICE",
	Unknown: "UNKNOWN",
};

const getErrorType = (reason: Object) => {
	const error = CAMERA_ERRORS[reason.name];
	return error || CAMERA_ERRORS.Unknown;
};

export const isSupported = () => (self.navigator.mediaDevices
    && self.navigator.mediaDevices.getUserMedia)
    || self.navigator.getUserMedia;

export default (constraints: Object = {}): Promise<Object> => {
	let promise;

	if (self.navigator.mediaDevices && self.navigator.mediaDevices.getUserMedia) {
		promise = self.navigator.mediaDevices.getUserMedia(constraints)
			.catch((reason) => Promise.reject({ reason: getErrorType(reason) }));
	} else {
		promise = new Promise((resolve: Function, reject: Function) => {
			self.navigator.getUserMedia(constraints,
				resolve, (e) => {
					reject({ reason: getErrorType(e) });
				});
		});
	}

	return promise;
};
